var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemperature(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 50,
    viewBox: "0 0 30 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 28.3V5.3C16.8 2.4 14.4 0 11.5 0C8.6 0 6.2 2.4 6.2 5.3V28.3C2.4 30.2 0 34.2 0 38.5C0 41.8 1.4 44.9 3.9 47.1C6 49 8.7 50 11.6 50C12.1 50 12.5 50 13 49.9C18.2 49.3 22.4 45.1 23 39.9C23.4 35.1 21 30.5 16.8 28.3ZM11.5 44.6C8.1 44.6 5.4 41.9 5.4 38.5C5.4 35.5 7.6 33 10.5 32.5V6.6C10.5 6 10.9 5.6 11.5 5.6C12.1 5.6 12.5 6 12.5 6.6V32.5C15.4 33 17.6 35.5 17.6 38.5C17.5 41.9 14.8 44.6 11.5 44.6Z",
    fill: "url(#paint0_linear_2119_2920)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6016 11.9004H25.9016C26.5016 11.9004 26.9016 11.5004 26.9016 10.9004C26.9016 10.3004 26.5016 9.90039 25.9016 9.90039H21.6016C21.0016 9.90039 20.6016 10.3004 20.6016 10.9004C20.6016 11.5004 21.1016 11.9004 21.6016 11.9004Z",
    fill: "url(#paint1_linear_2119_2920)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9984 14H23.3984C22.7984 14 22.3984 14.4 22.3984 15C22.3984 15.6 22.7984 16 23.3984 16H28.9984C29.5984 16 29.9984 15.6 29.9984 15C29.9984 14.4 29.5984 14 28.9984 14Z",
    fill: "url(#paint2_linear_2119_2920)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9016 18.0996H21.6016C21.0016 18.0996 20.6016 18.4996 20.6016 19.0996C20.6016 19.6996 21.0016 20.0996 21.6016 20.0996H25.9016C26.5016 20.0996 26.9016 19.6996 26.9016 19.0996C26.9016 18.4996 26.5016 18.0996 25.9016 18.0996Z",
    fill: "url(#paint3_linear_2119_2920)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2119_2920",
    x1: 11.5216,
    y1: 0,
    x2: 11.5216,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A86D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4AB2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2119_2920",
    x1: 23.7516,
    y1: 9.90039,
    x2: 23.7516,
    y2: 11.9004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A86D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4AB2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2119_2920",
    x1: 26.1984,
    y1: 14,
    x2: 26.1984,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A86D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4AB2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2119_2920",
    x1: 23.7516,
    y1: 18.0996,
    x2: 23.7516,
    y2: 20.0996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A86D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4AB2A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/temperature.0e578fd63fd5387f9fe4bbcdbc2eef6e.svg";
export { ForwardRef as ReactComponent };